import style from '../CSS/RoundVideoResult.module.css'

const Title = ({title}) => {
    return (
        <>
            <div className={style.title}>
                <h5>{title}</h5>
            </div>
        </>
    );
};

export default Title;